/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { configureStore, combineReducers } from '@reduxjs/toolkit';

import { sarsaparillaReducers } from 'sarsaparilla';
import { authReducers } from 'shared-ui/auth/redux';

import { externalRatingReviewsReducers } from 'ui-rating-review';

import activitypassReducers from '../src/reducers';

const rootReducer = combineReducers({
    activitypass: activitypassReducers,
    ratingReviews: externalRatingReviewsReducers,
    ...sarsaparillaReducers,

    // Auth - MUST COME AFTER SARSA REDUCERS DURING AUTH MIGRATION
    ...authReducers,
});

export function setupStore(preloadedState?: any) {
    return configureStore({
        reducer: rootReducer,
        middleware: (getDefaultMiddleware) => {
            return getDefaultMiddleware({
                serializableCheck: {
                    ignoredActions: ['launchdarkly/setClient'],
                    ignoredPaths: [
                        'launchdarkly', // Has ld client object in reducer
                    ],
                },
            });
        },
        preloadedState,
        devTools: process.env.DEV_TOOLS_ENABLED,
    });
}

export const store = setupStore();

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppStore = typeof store;

// cSpell:ignore activitypass, reduxjs
